module.exports = __webpack_public_path__ + "static/media/EVA_Logo_2022_February_for_dark_background.7c0e2713.svg";